/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["__mwsShowroom__webpackJsonp"];
/******/ 	window["__mwsShowroom__webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/ 			script.crossOrigin = 'anonymous';
/******/ 			script.src = __webpack_require__.p + "" + chunkId + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

var browserSupport = __webpack_require__(337);

if (!browserSupport.canRunShowroom()) {
    window.onerror = function () {
        return true; // prevent default event handler //
    };
    document.write('<script src="/upgradebrowser.js?_' + Math.round(Math.random() * 1000000) + '"></sc' + 'ript>');
}



/***/ }),

/***/ 337:
/***/ (function(module, exports) {

/**
 * Checks if current browser is supported for running the app
 *
 * !! This is run in the bootstrap, so no TypeScript or ES5+ syntax here
 */
module.exports = {
    canRunShowroom: function () {
        // check browser support; we need flexbox and es5 support //
        var testEl = document.createElement('div'),
            props = ['flexWrap', 'FlexWrap', 'WebkitFlexWrap', 'MozFlexWrap', 'msFlexWrap'],
            cssPrefixes = ['', '-webkit-', '-moz-', '-ms-'],
            supportsFlex = false,
            supportsEs5 = Function.prototype.hasOwnProperty('bind'),
            i;

        for(i = 0; i < props.length; i++) {
            if (testEl.style[props[i]] !== undefined) {
                supportsFlex = true;
                break;
            }
        }

        // extra check for browsers with wrong flexbox implementations (ex.: IE10) //
        if (supportsFlex) {
            supportsFlex = false;
            for (i = 0; i < cssPrefixes.length; i++) {
                testEl.style.display = cssPrefixes[i] + "flex";
                if (testEl.style.display === (cssPrefixes[i] + "flex")) {
                    supportsFlex = true;
                    break;
                }
            }
        }

        return supportsFlex && supportsEs5;
    }
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// browserCheck.js